// extracted by mini-css-extract-plugin
export var csatScore = "_kg-5";
export var header = "_kg-1";
export var panelWrapper = "_kg-2";
export var postPreview = "_kg-3";
export var rightContent = "_kg-0";
export var wrappingText = "_kg-4";